import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import type { DashboardStats, PagedResult, Product } from "@/types";

export function useStockAlerts() {
  const { data: stats } = useQuery<DashboardStats>({
    queryKey: ["dashboard-stats"],
    queryFn: async () => {
      const { data } = await api.get("/api/admin/dashboard/stats");
      return data;
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
  });

  const totalAlerts =
    (stats?.outOfStockProductCount ?? 0) + (stats?.lowStockProductCount ?? 0);

  const { data: productsData, isLoading } = useQuery<PagedResult<Product>>({
    queryKey: ["stock-alert-products"],
    queryFn: async () => {
      const { data } = await api.get("/api/admin/products", {
        params: { pageSize: 100, page: 1 },
      });
      return data;
    },
    enabled: totalAlerts > 0,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });

  const allProducts = productsData?.items ?? [];
  const outOfStockProducts = allProducts.filter((p) => p.stock === 0);
  const lowStockProducts = allProducts.filter((p) => p.stock > 0 && p.stock <= 10);

  return {
    outOfStockCount: stats?.outOfStockProductCount ?? 0,
    lowStockCount: stats?.lowStockProductCount ?? 0,
    totalAlerts,
    outOfStockProducts,
    lowStockProducts,
    isLoading,
  };
}
